import LinkButton from "ds/components/Button/LinkButton";
import Tooltip from "ds/components/Tooltip";
import useCanCreateScan from "shared/Scan/access/useCanCreateScan";

type ScheduleScanButtonProps = {
  disabled?: boolean;
};

const ScheduleScanButton = ({ disabled }: ScheduleScanButtonProps) => {
  const canCreateScan = useCanCreateScan();
  const isDisabled = disabled || !canCreateScan.result;

  return (
    <Tooltip
      active={!!canCreateScan.message}
      on={(props) => (
        <LinkButton {...props} variant="primary" disabled={isDisabled} to="/new/scan">
          Schedule scan
        </LinkButton>
      )}
    >
      {canCreateScan.message}
    </Tooltip>
  );
};

export default ScheduleScanButton;
